export const SMS_OPTIN_COPY =
  'Get exclusive discounts and cart reminders from Vivrelle via text. Msg & Data rates may apply. Msg frequency may vary. Reply HELP for help. Reply STOP to opt-out.';
